import BoxWidget from '@/components/box-widget/BoxWidget.vue';

export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    BoxWidget,
  },
  computed: {
    itemsList() {
      return this.items
        .map(item => this.$t(
          'fn.complex.creative-logs-title',
          { type: item.type, id: item.creative_id, timestamp: item.created_at }),
        );
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/lab/creative-logs/CreativeLogs.js